import { render, staticRenderFns } from "./userUpdate.vue?vue&type=template&id=6830557c&scoped=true"
import script from "./userUpdate.ts?vue&type=script&lang=ts&external"
export * from "./userUpdate.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6830557c",
  null
  
)

export default component.exports